import React from "react";
import styled from "styled-components";
import { withTheme } from "@material-ui/styles";

const Logo = ({ theme, ...props }) => (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 280 164"
    alt="PureCars"
    {...props}
  >
    <title>PureCars</title>
    <path
      d="M282.1.5S275.4.4,271.8.4a54.9,54.9,0,0,0-20.7,4.4,53.15,53.15,0,1,0,65.8,77.5,91.12,91.12,0,0,0,5-8.9c1.8-3.6,3.3-7,4.5-10.1H310.2a12.76,12.76,0,0,0-11.5,7.1l-.3.5a29.39,29.39,0,0,1-8.9,9,24.91,24.91,0,0,1-5.1,2.7A31.76,31.76,0,0,1,243,66.1a29.6,29.6,0,0,1-2.6-11.3A31.08,31.08,0,0,1,259.3,25a29.11,29.11,0,0,1,11.8-2.5Z"
      transform="translate(-82.5 -0.15)"
      fill="#039ac4"
    />
    <polygon
      points="229.8 0.45 199.6 0.35 188.5 22.35 218.7 22.55 229.8 0.45"
      fill="#5ec0d6"
    />
    <path
      d="M301.2,22.7l32,.1a11.07,11.07,0,0,0,9.9-6.2L351,.9,312.3.6Z"
      transform="translate(-82.5 -0.15)"
      fill="#f0563c"
    />
    <path
      d="M152.1,51s4.7-9.2,6.3-12.5a32.2,32.2,0,0,1,7.8-9.8,31,31,0,0,1,35.1-3.3,30.43,30.43,0,0,1,8.9,7.5,31.86,31.86,0,0,1-4.1,44.5,40.72,40.72,0,0,1-4.8,3.3,32.18,32.18,0,0,1-5,2.3,29.36,29.36,0,0,1-10.2,1.5l-13.7-.1a11.39,11.39,0,0,0-10.1,6.1l-5.4,10.7h0l-2.2,4.7,33.7.2a36.69,36.69,0,0,0,6.6-.5,52,52,0,0,0,16.7-5.9,50.17,50.17,0,0,0,8.1-5.5,53.13,53.13,0,0,0,7-74.8A52.37,52.37,0,0,0,211.7,6.8a53.36,53.36,0,0,0-73,22c-.3.5-11.2,22.3-11.2,22.3Z"
      transform="translate(-82.5 -0.15)"
      fill="#039ac4"
    />
    <polygon
      points="55.9 78.15 69.6 50.85 44.9 50.85 31.1 78.15 55.9 78.15"
      fill="#5ec0d6"
    />
    <path
      d="M113.5,113.7a11.22,11.22,0,0,0,10-6l4-7.7,10.9-21.7H113.6L95.9,113.6Z"
      transform="translate(-82.5 -0.15)"
      fill="#f0563c"
    />
    <path
      d="M327,154.5l3-.9a1.79,1.79,0,0,1,2.2.9,10.16,10.16,0,0,0,9.2,5.2c4.4,0,7.2-2.4,7.2-4.9,0-2.1-1.3-3.4-5-4.6l-7.9-2.5c-4.2-1.3-7.1-3.7-7.1-7.7,0-4.7,4.5-8.6,10.9-8.6,6.7,0,11.4,3.6,13.2,7.8l-3.1.9a2,2,0,0,1-2.1-.8,9.75,9.75,0,0,0-8-3.7c-3.6,0-6,1.9-6,4.2,0,1.8,1.2,2.9,4,3.7l7.7,2.5c4.9,1.5,8.2,3.6,8.2,8.4,0,5.3-4.9,9.5-12.3,9.5A14.33,14.33,0,0,1,327,154.5Z"
      transform="translate(-82.5 -0.15)"
      fill="#0d4466"
    />
    <path
      d="M305.9,152h-8v11.7H293V132.2h15a9.88,9.88,0,0,1,10.3,9.9,9.56,9.56,0,0,1-7.3,9.4l8.1,12.1h-4.6a1.7,1.7,0,0,1-1.6-.9Zm-7.9-4.3h9.8a5.56,5.56,0,1,0,.1-11.1h-10Z"
      transform="translate(-82.5 -0.15)"
      fill="#0d4466"
    />
    <path
      d="M277.3,155.8h-15l-3,7.6h-5.1l12.5-31.5h6.2l12.5,31.5h-3.8a2,2,0,0,1-1.8-1.2Zm-1.7-4.4-5.8-14.9L264,151.4Z"
      transform="translate(-82.5 -0.15)"
      fill="#0d4466"
    />
    <path
      d="M217.5,147.6a16,16,0,0,1,16.4-16.3c8,0,13.3,4.7,15,9.8l-3.1.8a2,2,0,0,1-2.2-.9,11,11,0,0,0-9.7-5.2c-6.9,0-11.4,5.4-11.4,11.7s4.5,11.8,11.4,11.8c4.5,0,8-2.2,9.6-5.1a2,2,0,0,1,2.2-.9l3.1.8c-1.7,5.1-7,9.8-14.9,9.8A16,16,0,0,1,217.5,147.6Z"
      transform="translate(-82.5 -0.15)"
      fill="#0d4466"
    />
    <path
      d="M202.7,136.3h5.9a2.4,2.4,0,0,0,2-1.2l1.6-3.2H187.9v31.5h22.6V159H192.7v-9.4h15.6v-4.2H192.7v-9h10Z"
      transform="translate(-82.5 -0.15)"
      fill="#0d4466"
    />
    <path
      d="M164.7,152h-8v11.7h-4.9V132.2h15a9.88,9.88,0,0,1,10.3,9.9,9.56,9.56,0,0,1-7.3,9.4l8.1,12.1h-4.6a1.7,1.7,0,0,1-1.6-.9Zm-7.9-4.3h9.8a5.56,5.56,0,1,0,.1-11.1h-10v11.1Z"
      transform="translate(-82.5 -0.15)"
      fill="#0d4466"
    />
    <path
      d="M142.1,131.9v18.8c0,7.9-4.8,13.3-13.3,13.3s-13.3-5.4-13.3-13.3V131.9h4.9v18.7c0,5.2,2.8,8.9,8.4,8.9s8.4-3.7,8.4-8.9V134.3a2.26,2.26,0,0,1,2.3-2.3h0Z"
      transform="translate(-82.5 -0.15)"
      fill="#0d4466"
    />
    <path
      d="M107.5,142.5a10.48,10.48,0,0,0-10.7-10.6H82.5v31.5h4.9V136.3h9.4a6.16,6.16,0,0,1,.3,12.3H93.4a2.09,2.09,0,0,0-2,1.3l-1.1,2.2h0l-.5,1,7.4.1h.1A10.76,10.76,0,0,0,107.5,142.5Z"
      transform="translate(-82.5 -0.15)"
      fill="#0d4466"
    />
  </svg>
);

const ThemeLogo = styled(Logo)``;

export default withTheme((props) => <ThemeLogo {...props} />);
